import styled from 'styled-components';
import { TooltipPosition } from '.';

export interface ContentProps {
  $maxWidth?: number;
  $position?: TooltipPosition;
}

export interface TooltipProps {
  $hasTruncation?: boolean;
}

export const Content = styled.div<ContentProps>`
  position: fixed;
  transform: ${({ $position }) =>
    $position === TooltipPosition.RIGHT || $position === TooltipPosition.LEFT
      ? 'translate(0, -50%)'
      : 'translate(-50%, 0)'};
  color: ${({ theme }) => theme.colors.grayLight};
  background-color: ${({ theme }) => theme.colors.black};
  width: max-content;
  max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : '400px')};
  padding: 0.5rem 1rem;
  border-radius: 4px;
  z-index: 10000;
  font-size: 14px;
  overflow-wrap: break-word;

  &::before {
    content: '';
    position: absolute;
    z-index: 10000;
    ${({ $position, theme }) => {
      if ($position === TooltipPosition.RIGHT) {
        return `
          right: 100%;
          top: 50%;
          transform: translateY(-50%);
          border-color: transparent ${theme.colors.black} transparent transparent;`;
      }
      if ($position === TooltipPosition.LEFT) {
        return `
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
          border-color: transparent transparent transparent ${theme.colors.black};
        `;
      }
      return `
        bottom: 100%;
        left: 50%;
        margin-left: -5px;
        border-color: transparent transparent ${theme.colors.black} transparent;
      `;
    }}
    border-width: 5px;
    border-style: solid;
  }
`;

export const Tooltip = styled.span<TooltipProps>`
  position: relative;
  max-width: ${({ $hasTruncation }) => ($hasTruncation ? '100%' : 'auto')};
  display: inline-grid;
`;
